import React from 'react';
import { cn } from '../lib/utils';

interface NavButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  delay?: number;
}

export const NavButton = React.forwardRef<HTMLButtonElement, NavButtonProps>(
  ({ children, onClick, className, delay = 0, ...props }, ref) => {
    return (
      <button
        ref={ref}
        onClick={onClick}
        className={cn(
          "nav-box-item group relative px-5 py-3",
          "bg-white/90 hover:bg-white",
          "text-slate-800 hover:text-slate-900",
          "font-semibold text-sm",
          "rounded-xl border border-slate-200/50 hover:border-slate-300",
          "shadow-lg hover:shadow-2xl",
          "transition-all duration-300 transform hover:scale-110 hover:-translate-y-1",
          "backdrop-blur-sm",
          "focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2",
          className
        )}
        style={{
          animationDelay: `${delay}s`,
          animation: 'navItemEntrance 0.6s ease-out forwards'
        }}
        {...props}
      >
        <div className="flex items-center gap-2 relative z-10">
          {children}
        </div>
        
        {/* Animated underline */}
        <div className="absolute bottom-0 left-1/2 w-0 h-1 bg-gradient-to-r from-cyan-500 to-emerald-500 group-hover:w-full group-hover:left-0 transition-all duration-300 rounded-full" />
        
        {/* Glow effect */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-cyan-400/0 via-emerald-400/0 to-cyan-400/0 group-hover:from-cyan-400/10 group-hover:via-emerald-400/10 group-hover:to-cyan-400/10 transition-all duration-300" />
        
        {/* Click ripple effect */}
        <div className="absolute inset-0 rounded-xl opacity-0 group-active:opacity-20 group-active:animate-ping bg-gradient-to-r from-cyan-500 to-emerald-500" />
      </button>
    );
  }
);

NavButton.displayName = 'NavButton';